import React,{useEffect,useState} from 'react';
import {
    Col,
    Card,
    CardImgOverlay,
    CardBody,
    CardImg,
    Row,
    Button
} from "reactstrap";
import Panel from "../../../../shared/components/Panel";
import {connect} from "react-redux";
import ModelProduct from '../../../../Models/Product';
import { Line } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
import {setPriceHistoryRange, setRatingHistoryRange} from "../../../../redux/actions/themeActions";
Chart.register(...registerables);



const RatingHistory = ({dispatch,ratingTrackerData,productData}) => {

    const mv = new ModelProduct();
    const [data,setData] = useState(false);
    const [dateRange,setDateRange] = useState(14);
    const [isLoaded,setLoaded] = useState(false);

    useEffect(()=>{
        fetchData(productData.p_id,dateRange);
    },[])

    const fetchData =(p_id,dateRange)=>{
        mv.getRatingHistory(productData.p_id,dateRange).then(response=>{
            setChartData(response.data.data)

            setLoaded(true);
        });
    };

    const options = {
        legend: {
            position: 'bottom',
        },
        scales: {
            xAxes: [
                {
                    gridLines: {
                        color: 'rgb(204, 204, 204)',
                        borderDash: [3, 3],
                    },
                    ticks: {
                        autoSkip: true,
                        fontColor: 'rgb(204, 204, 204)',
                    },
                },
            ],
            yAxes: [
                {
                    gridLines: {
                        color: 'rgb(204, 204, 204)',
                        borderDash: [3, 3],
                    },
                    ticks: {
                        fontColor: 'rgb(204, 204, 204)',
                    },
                },
            ],
        },
    };

    const setChartData=(data)=>{
        let linePoints=[];
        let xaxis = [];
        if(data!== false && data !==null){
            data.forEach((rating)=>{
                linePoints.push(rating.rt_rating);
                xaxis.push(rating.rt_created);
            });
        }
        setData({
            labels: xaxis,
            datasets: [
                {
                    label: 'Amazon',
                    fill: false,
                    lineTension: 0.3,
                    backgroundColor: '#FFCE56',
                    borderColor: '#FFCE56',
                    borderWidth: 1,
                    pointBackgroundColor: '#FFCE56',
                    pointHoverRadius: 5,
                    pointHoverBorderWidth: 1,
                    pointRadius: 4,
                    pointHitRadius: 10,
                    data: linePoints,
                },
                // {
                //     label: 'Green',
                //     fill: false,
                //     lineTension: 0.3,
                //     backgroundColor: '#4BC0C0',
                //     borderColor: '#4BC0C0',
                //     borderWidth: 1,
                //     pointBackgroundColor: '#4BC0C0',
                //     pointHoverRadius: 6,
                //     pointHoverBorderWidth: 1,
                //     pointRadius: 5,
                //     pointHitRadius: 10,
                //     data: [52, 47, 45, 4, 58, 7, 45],
                // },
            ],
        });
    }

    const onDateRangeChange=(e)=>{
        dispatch(setRatingHistoryRange(e.target.value));
        fetchData(productData.p_id,e.target.value);
    };

    return (
        data!== false &&
        <Card>
            <CardBody>
                <div className="card__title" style={{display:"flex"}}>
                    <h5 className="bold-text mr-auto">Rating History</h5>
                    <select onChange={onDateRangeChange}>
                        <option value="14">14 Days</option>
                        <option value="30">30 Days</option>
                        <option value="60">60 Days</option>
                        <option value="180">6 Months</option>
                        <option value="365">1 Year</option>
                        <option value="730">2 Years</option>
                    </select>
                </div>
                <Line data={data} options={options} />
            </CardBody>
        </Card>

    );
};

export default connect(state => ({
    ratingTrackerData:state.product.ratingTrackerData,
    productData:state.product.productData
}))(RatingHistory);

